import { createContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from '../redux/store';
import { getOrders } from '../redux/slices/order';

const OrderPollingContext = createContext();

export function OrderPollingProvider({ children }) {
  const dispatch = useDispatch();
  useEffect(() => {
    const intervalSeconds = parseInt(process.env.REACT_APP_ORDER_POLL_INTERVAL, 10) || 30;
    dispatch(getOrders());
    const interval = setInterval(() => {
      dispatch(getOrders());
    }, intervalSeconds * 1000);
    return () => clearInterval(interval);
  }, [dispatch]);
  return <OrderPollingContext.Provider value={{}}>{children}</OrderPollingContext.Provider>;
}

OrderPollingProvider.propTypes = {
  children: PropTypes.node
};
